import { helper } from '@ember/component/helper';

export function isIn([arr, item]) {
  return !!arr?.find((element) => element === item);
}

export default helper(isIn);
